module.exports = __webpack_public_path__ + "media/images/star-356d17d2b55c97bc3607a7a5cf98dba9.svg";